import React, {Component} from "react";
import {Nav, Table} from "react-bootstrap";
import axios from "axios";
import {ClockLoader} from "react-spinners";
import Moment from "moment";

//TODO: the refresh needs a timer on it. Otherwise it just runs all the time

export class ClosedServiceOrdersReport extends Component{

    constructor() {
        super();
        this.state = {
            filterOption: '',
            filteredData: [],
            newData: [],
            invoiceIsLoading: true,
            sum: [],
            userInfo: [],
        };
    }

    componentDidMount() {
        const userInfo =  JSON.parse(localStorage.getItem('userInfo')) ?? {};
        axios.get('https://homesafetysolutions.pythonanywhere.com/api/closed_serviceorder_report/',{
            headers:{
                "Accept":'application/json',
                "Content-Type":'application/json',
                Authorization: `Bearer ${userInfo.token}`,
            },
        })
            .then(response=>{
                this.setState({newData: response.data});
                this.setState({invoiceIsLoading: false});
            })
    }

    optionSelected(e) {
        this.setState({
            filterOption: e.target.value,
        });
    }

    renderTableData(newData) {
        return newData.map((element, i) => (
            <tr key={i}>
                <td>{Moment(element.created).format("MM/DD/YYYY  hh:mm:ss a")}</td>
                <td>{element.client_name}</td>
                <td>{element.service_order_done}</td>
                <td>{element.rework}</td>
                <td>{element.bill_amount}</td>
                <td>{element.payment_made_in_full}</td>
                <td>{element.ready_to_invoice}</td>
                <td>{element.service_order_comments}</td>
            </tr>
        ));
    };

    renderFilterOptions(filterOption) {
        if(filterOption) {
            let { newData } = this.state;
            let options = Array.from(new Set(newData.map(element => element[filterOption])));
            return options.map((option,i) => <option key={i} value={option}> {option} </option>)
        }
        return []
    };

    filterOptionSelected(e) {
        let {value} = e.target;
        if(value) {
            let { filterOption, newData } = this.state
            let filteredData = newData.filter(element => element[filterOption] === value);

            const getSum = filteredData.reduce((obj, {bill_amount}) => {
                obj[bill_amount] = bill_amount;
                return obj;
            }, {});

            let sum = 0;
            for (const value of Object.values(getSum)) {
                sum += parseInt(value);
            }

            this.setState({
                filteredData: filteredData,
                getSum: getSum,
                sum: sum.toFixed(2),
            });
        }
    };


    render() {
        let { filterOption, filteredData, newData, invoiceIsLoading, sum} = this.state

        if (invoiceIsLoading){
            return <div className={'loadingSpinner'} >Loading...<br/> <ClockLoader color="#0d00ff" /></div>
        }

        return (
            <div>

                <Nav variant="tabs" defaultActiveKey="/finance_reports" className={'reports_nav_heading'}>
                    <Nav.Item>
                        <Nav.Link href="#/open_service_order_report">Open Service Orders</Nav.Link>
                    </Nav.Item>
                    <Nav.Item>
                        <Nav.Link eventKey="disabled" disabled >Closed Service Orders</Nav.Link>
                    </Nav.Item>
                    <Nav.Item>
                        <Nav.Link href="#/custom_service_order_report">Custom Reports</Nav.Link>
                    </Nav.Item>
                </Nav>
                <h1 className={'perposalInvoiceHeaders'}>Closed Service Order Report</h1>
                <div>
                    <label>Filter By:</label>
                    <br/>
                    <select onChange={this.optionSelected.bind(this)}>
                        <option value="">  </option>
                        <option value="client">Client</option>
                        <option value="year">Year</option>
                        <option value="year_and_month">Month & Year</option>
                    </select>

                    <select onChange={this.filterOptionSelected.bind(this)}>
                        <option value="">  </option>
                        {this.renderFilterOptions(filterOption)}
                    </select>
                </div>
                <Table responsive="lg" className={'mt-4'} striped bordered hover size={'lg'}>
                    <thead>
                    <th>S.O. Created On:</th>
                    <th>Client Name:</th>
                    <th>Service Order Done?:</th>
                    <th>Rework?:</th>
                    <th>Bill Amount:</th>
                    <th>Payment Made In Full:</th>
                    <th>Ready To Invoice:</th>
                    <th>Service Order Comments: </th>
                    </thead>
                    <tbody>
                    {
                        filteredData.length ? this.renderTableData(filteredData) : this.renderTableData(newData)
                    }
                    <div className={'reportsSum'}>
                        TOTAL: {sum}
                    </div>

                    </tbody>
                </Table>
            </div>
        );
    }
}

export default ClosedServiceOrdersReport;
